import React from 'react';
import styled from 'styled-components';
import { Card, Paragraph } from '@studio/legacy-components';
import AppIcon from './AppIcon';
import CreateAppManager from './CreateAppManager';

const ActionColumn = styled.div``;

const IconColumn = styled.div`
  margin-right: 8px;
`;

const Content = styled.div`
  align-items: center;
  display: flex;
  height: 100%;
`;

const AddAppCard = () => {
  return (
    <Card>
      <Content>
        <IconColumn>
          <AppIcon />
        </IconColumn>
        <ActionColumn>
          <Paragraph>
            Deliver mobile-optimized Appcues Flows to your native iOS or Android
            apps.
          </Paragraph>
          <CreateAppManager />
        </ActionColumn>
      </Content>
    </Card>
  );
};

export default AddAppCard;
